import VideoPlayCircleIcon from '@atlaskit/icon-lab/core/video-play-circle';
import * as React from 'react';

export function SvgPlayCircle() {
  return <VideoPlayCircleIcon label="" testId="ads-refreshed-icon" />;
}
